import React from "react";
import "../components/Us.css";
import banner from "../Assets/Images/us-photo.jpg";


function Us() {
  return (
    <div id="about" className="hero min-h-screen text-white" >
      {/* <div id="About" className="AboutSection container mx-auto py-8" style={{marginTop:"0px"}}> */}
        {/* <br /> <br /> */}
        {/* <section className="aboutSection">
          <h2 className="h2 text-center section-title text-red-500 text-xl">
            Who We are
          </h2>
          <div className="container1 mt-20">
            
            <div className="about-content w-full mb-20 flex flex-col md:flex-row items-center justify-center md:items-stretch">
               <img
                className="w-full h-full md:w-1/2 ml-0 md:ml-8 mb-4 md:mb-0 ml-20px"
                src={banner}
                alt="Banner"
              />
<h2 className="h2 about-title h2 text-center section-title text-red-500 md:w-1/4 md:text-right md:mr-8">
              About Us
            </h2>
              <p className="about-text w-full md:w-3/4 text-justify text-sm ml-20">
 Isiolo Advocacy Network is a youth-led community based Organization working in Isiolo county to achieve social justice, gender equality, and poverty eradication.
 We commit to working with youth especially young women to claim and realize their institutional rights through working within three pillars empowerment, solidarity and campaigning.
              </p>
             
            </div>
          </div>
        </section> */}


        <section className="py-20 bg-gray-50">
  <div className="max-w-7xl mx-auto px-6 lg:px-12">

    {/* Title */}
   

    {/* Content */}
    <div className="grid md:grid-cols-2 gap-12 items-center">

      {/* Image */}
      <div>
        <img
          src={banner}
          alt="Banner"
          className="rounded-2xl shadow-xl w-full h-[500px] object-cover"
        />
      </div>

      {/* Text */}
      <div>
         <h2 className="text-xl md:text-2xl font-bold text-red-500 mb-6 inline-block border-b-4 border-red-500 ">
      Who We are
    </h2>
        <p className="text-gray-600 leading-relaxed text-sm text-justify">
          Isiolo Advocacy Network is a youth-led community based Organization working in Isiolo county to achieve social justice, gender equality, and poverty eradication.
          We commit to working with youth especially young women to claim and realize their institutional rights through working within three pillars empowerment, solidarity and campaigning.
        </p>
      </div>

    </div>
  </div>
</section>
        {/* <br /> */}
      {/* </div> */}
    </div>
  );
}

export default Us;
